import { useState } from 'react';

/** A command to run, with a Copy button. */
export function CopyCommand({ command, label }: { command: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(command);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard blocked: the command is still there to select by hand.
    }
  }

  return (
    <div className="flex flex-wrap items-stretch gap-2">
      <code className="min-w-0 flex-[1_1_280px] overflow-x-auto rounded-[6px] border border-line bg-field px-3.5 py-3 font-mono text-[13px] whitespace-nowrap">
        {command}
      </code>
      <button
        type="button"
        onClick={copy}
        aria-label={label ? `Copy: ${label}` : 'Copy the command'}
        className="inline-flex min-h-11 items-center rounded-full border border-line bg-card px-4 text-sm font-semibold text-ink hover:border-muted"
      >
        {copied ? 'Copied' : 'Copy'}
      </button>
    </div>
  );
}
